import moment from 'moment'

import type { TimeDeadline } from './types'

export function filterByDeadline(timestamp: string, deadline: TimeDeadline) {
  const now = moment().local()
  const endOfAMShift = moment().set({ hour: 16, minute: 0, second: 0, millisecond: 0 })
  const endOfPMShift = moment().set({ hour: 4, minute: 0, second: 0, millisecond: 0 })
  if (endOfPMShift.isBefore(moment())) endOfPMShift.add(1, 'd')

  const eod = moment(now).endOf('day').local()
  const timeBeingChecked = moment(timestamp).local()
  switch (deadline) {
    case 'now':
      return timeBeingChecked.isBefore(now)
    case 'am today':
      return timeBeingChecked.isBefore(endOfAMShift)
    case 'pm today':
      return timeBeingChecked.isBefore(endOfPMShift)
    case 'today':
      return timeBeingChecked.isBefore(eod)
    case 'tomorrow':
      return timeBeingChecked.isBefore(eod.add(1, 'd'))
    default:
      return timeBeingChecked.isBefore(moment().add(deadline, 'h'))
  }
}

export function checkIsAmShift() {
  // Define 4 AM and 4 PM for today
  const fourAM = moment().set({ hour: 4, minute: 0, second: 0, millisecond: 0 })
  const fourPM = moment().set({ hour: 16, minute: 0, second: 0, millisecond: 0 })

  // Check if the current time is between 4 AM and 4 PM
  return moment().isBetween(fourAM, fourPM)
}
